var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.122,
    height: 23.122,
    viewBox: "0 0 23.122 23.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(1.061 1.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M15822.926,13692.5l-10.5,10.5,10.5-10.5-10.5-10.5,10.5,10.5,10.5-10.5-10.5,10.5,10.5,10.5Z",
    transform: "translate(-15812.426 -13682)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ec83058ad4c294b070081544dd27c3f7.svg";
export { ForwardRef as ReactComponent };